import React from "react"
export const SearchListUIContext = React.createContext({})
